module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!!_vm.message) ? _c('messages', {
    attrs: {
      "size": "middle",
      "message": _vm.message,
      "error": _vm.error
    }
  }) : _c('form-layout', [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Задать вопрос по ПФ ДОД")]), _c('app-textarea', {
    attrs: {
      "slot": "textarea",
      "placeholder": "Ваш вопрос",
      "name": "question",
      "error-text": "Обязательное поле",
      "rows": 6,
      "v": _vm.$v.formData.question
    },
    slot: "textarea",
    model: {
      value: (_vm.formData.question),
      callback: function($$v) {
        _vm.$set(_vm.formData, "question", $$v)
      },
      expression: "formData.question"
    }
  }), _c('app-radio', {
    attrs: {
      "slot": "radio",
      "label": "Получить ответ на почту",
      "value": "mail",
      "id": "mail",
      "modelValue": _vm.radio
    },
    slot: "radio",
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }), _c('app-radio', {
    attrs: {
      "slot": "radio",
      "label": "Получить ответ по телефону",
      "value": "phone",
      "id": "phone",
      "modelValue": _vm.radio
    },
    slot: "radio",
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }), (_vm.radioState) ? _c('app-input', {
    key: "email",
    attrs: {
      "slot": "input",
      "name": "email",
      "placeholder": "Ваша эл.почта",
      "error-text": "Укажите правильный адрес e-mail",
      "v": _vm.$v.formData.email
    },
    slot: "input",
    model: {
      value: (_vm.formData.email),
      callback: function($$v) {
        _vm.$set(_vm.formData, "email", $$v)
      },
      expression: "formData.email"
    }
  }) : _vm._e(), (!_vm.radioState) ? _c('app-input', {
    key: "email",
    attrs: {
      "slot": "input",
      "name": "phone",
      "placeholder": "Ваш телефон",
      "error-text": "Пожалуйста, введите корректный номер мобильного телефона.",
      "mask": _vm.phoneMask,
      "v": _vm.$v.formData.phone
    },
    slot: "input",
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  }) : _vm._e(), _c('ext-button', {
    attrs: {
      "slot": "button",
      "size": 'normal'
    },
    on: {
      "click": _vm.submitForm
    },
    slot: "button"
  }, [_vm._v("Отправить")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15aeb681","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modalform/Modalform.vue
// module id = e136ce2ceb8303ee6434
// module chunks = 0